import { createActionsHook, createHook, createStore } from 'react-sweet-state';

export type Menu = 'conversation-list' | 'agents' | 'pulse' | 'none';

type State = {
	activeMenu: Menu;
	mounted: boolean;
	isAgentSelectorMenuOpen: boolean;
	streaming: boolean;
};

const initialState: State = {
	activeMenu: 'none',
	mounted: false,
	isAgentSelectorMenuOpen: false,
	streaming: false,
};

const store = createStore({
	name: 'uiStore',
	initialState,
	actions: {
		// created for resetting store during tests
		reset:
			() =>
			({ setState }) => {
				setState({
					...initialState,
				});
			},
		setActiveMenu:
			(menu: Menu) =>
			({ setState }) => {
				setState({ activeMenu: menu });
			},
		setMounted:
			(mounted: boolean) =>
			({ setState }) => {
				setState({ mounted });
			},
		setIsAgentSelectorMenuOpen:
			(isOpen: boolean) =>
			({ setState }) => {
				setState({ isAgentSelectorMenuOpen: isOpen });
			},
		setStreamingStatus:
			(status: boolean) =>
			({ setState }) => {
				setState({ streaming: status });
			},
	},
});

const useStore = createHook(store);

export const useUIStore = () => {
	const [
		{ activeMenu, mounted, streaming, isAgentSelectorMenuOpen },
		{ reset, setActiveMenu, setMounted, setIsAgentSelectorMenuOpen, setStreamingStatus },
	] = useStore();

	return {
		activeMenu,
		mounted,
		streaming,
		isAgentSelectorMenuOpen,
		reset,
		setActiveMenu,
		setMounted,
		setIsAgentSelectorMenuOpen,
		setStreamingStatus,
	};
};

export const useUIStoreActions = createActionsHook(store);
